export var UrlTokenType;
(function (UrlTokenType) {
    UrlTokenType["Faq"] = "FAQ";
    UrlTokenType["Video"] = "VIDEO";
})(UrlTokenType || (UrlTokenType = {}));
